import { trackException } from "services/errorTracker";

/*
This function tries to execute a FullStory function and reports
any errors as console warnings and to Sentry
*/
const tryFullStoryCommandWithFunction = (__function) => {
  try {
    __function();
  } catch (error) {
    trackException(error);
  }
};

/**
 * This function binds User properties to FullStory user objects
 * More on identify() here: https://help.fullstory.com/develop-js/identify
 *
 * @param {User} user
 */
export function identifyFullStoryUserWithUserRecord(user) {
  tryFullStoryCommandWithFunction(() => {
    window.FS.identify(user.id, {
      displayName: user.name || "",
      email: user.email,
      isAda_bool: user.email.includes("@ada.support")
    });
  }, "Will set user vars");
}

/**
 * This function binds Client properties to FullStory users
 *
 * @param {Client} client
 */
export function identifyFullStoryUserWithClientRecord(client) {
  tryFullStoryCommandWithFunction(() => {
    window.FS.setUserVars({
      clientHandle_str: client.handle || "",
      clientName_str: client.name || ""
    });
  });
}

/**
 * This function starts the recording of a FullStory session
 *
 */
export function startRecordingFullStorySession() {
  tryFullStoryCommandWithFunction(() => {
    window.FS.restart();
  });
}

/**
 * This function stops the recording of a FullStory session
 *
 */
export function stopRecordingFullStorySession() {
  tryFullStoryCommandWithFunction(() => {
    window.FS.shutdown();
  });
}
